import { adminRoutes } from 'app/constants/routes';
import { RouteBuilderItem } from 'app/routes/routeBuilder';

import { PayorsEdit, PayorsList, PayorsNew, PayorsShow } from './PayorRouteComponents';

const basePath = adminRoutes.payors;

export const payorRoutes: RouteBuilderItem[] = [
  /* eslint-disable @typescript-eslint/naming-convention */
  {
    Component: PayorsList,
    path: basePath,
  },
  {
    Component: PayorsNew,
    path: `${basePath}/new`,
  },
  {
    Component: PayorsShow,
    path: `${basePath}/:id`,
  },
  {
    Component: PayorsEdit,
    path: `${basePath}/:id/edit`,
  },
  /* eslint-enable @typescript-eslint/naming-convention */
];
